export default __webpack_public_path__ + "static/media/cat2.7c440aa5.jpg";